import { makeRequest } from '../../../../../api/makeRequest';

export const requestStatus = (data) => makeRequest({
  url: '/sebTariff/requestStatus/',
  method: 'post',
  headers: {
    'content-type': 'application/json',
  },
  data,
});
